import { render, staticRenderFns } from "./SpecialMarugame.vue?vue&type=template&id=057575e4"
import script from "./SpecialMarugame.vue?vue&type=script&lang=js"
export * from "./SpecialMarugame.vue?vue&type=script&lang=js"
import style0 from "./SpecialMarugame.vue?vue&type=style&index=0&id=057575e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports